import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { formatCurrency } from '../../helpers/custom';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Modal, Box, Divider, InputLabel, Select, CardActions, Backdrop, CircularProgress, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, Checkbox } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Neighbourhood from '../neighbourhood/Neighbourhood';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined, DeleteOutlined } from '@mui/icons-material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
        selectedHierarchies: any;
    };
}

export interface IState {
    pickup_id: string;
    pickup_details: any;
    customer_details: any;
    pageSize: number;
    anchorEl: any;
    transaction_data: any[];
    showEditPickupDetails: any;
    pickup_slot: any;
    agent: any;
    // location: any;
    status: any;
    payment: any;
    showEditCustomerDetails: any;
    name: any;
    mobile: any;
    email: any;
    house_number: any;
    street: any;
    locality: any;
    state: any;
    pincode: any;
    landmark: any;
    attended_customer: any;
    //////////////
    showLoader: any;
    showAddBag: boolean;
    bagUid: any;
    bagWeight: any;
    forceAddBag: any;
    showEditBag: boolean;
    showAddTransaction: boolean;
    transactionId: any;
    transactionType: any;
    transactionAmount: any;
    transactionComment: any;
    transactionIsCompleted: any;
    transactionIsCanceled: any;
    agentsLite: any;
    bagDetails: any;
    city: any;
    showChangeBatchAgent: boolean;
    showDeleteTransactionDialog: boolean;
    addWeightChecked: boolean;
  newWeight: any;
  showDeleteItemConfirmation: boolean,
  itemToDelete: null,
  showDeleteBagConfirmation: boolean,
  bagToDelete: null,
}

class PickupDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pickup_id: this.props.match.params.id,
            pickup_details: {},
            customer_details: {},
            pageSize: 5,
            anchorEl: null,
            transaction_data: [],
            showEditPickupDetails: false,
            pickup_slot: '',
            agent: '',
            // location: '',
            status: '',
            
            payment: '',
            showEditCustomerDetails: false,
            name: '',
            mobile: '',
            email: '',
            house_number: '',
            street: '',
            locality: '',
            state: 'Telangana',
            pincode: '',
            landmark: '',
            attended_customer: '',
            ////////
            showLoader: false,
            showAddBag: false,
            bagUid: '',
            bagWeight: '',
            forceAddBag: '',
            showEditBag: false,
            showAddTransaction: false,
            transactionId: '',
            transactionType: '',
            transactionAmount: '',
            transactionComment: '',
            transactionIsCompleted: '',
            transactionIsCanceled: '',
            agentsLite: [],
            bagDetails: [],
            city: '',
            showChangeBatchAgent: false,
            showDeleteTransactionDialog: false,
            addWeightChecked: false,
            newWeight: "",
            showDeleteItemConfirmation: false,
             itemToDelete: null,
             showDeleteBagConfirmation: false,
             bagToDelete: null,
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        // this.setState({
        //     pickup_details: {
        //         "pickup_id": 2266714,
        //         "pickup_type": "community",
        //         "batch": "#334423(pending)",
        //         "pickup_date": "2023-09-13",
        //         "pickup_slot": "Morning",
        //         "agent": "Not assigned",
        //         "zone": "Not Selected",
        //         "location": "Hyderabad",
        //         "status": "Pending",
        //         "payment": "Not applicable",
        //         "pickup_added": "2023-09-13 01:00:38",
        //         "qr_code_canned": "Not scanned yet"
        //     },
        //     customer_details: {
        //         "name": "S. Shanmukha Rao",
        //         "mobile": "9988667658",
        //         "email": "arjun.shasha2@gmail.com",
        //         "house_no": "7",
        //         "street": "Hill County Road",
        //         "locality": "Not assigned",
        //         "city": "Hyderabad",
        //         "state": "Telangana",
        //         "pincode": "500032",
        //         "landmard": "Not assigned",
        //         "attended_customer": "Not assigned",

        //     },
        //     transaction_data: [
        //         {
        //           "id": 342,
        //           "type": "Credit",
        //           "title": "Payment from Client A",
        //           "amount": 378,
        //           "updated": "2023-06-19"
        //         },
        //         {
        //           "id": 123,
        //           "type": "Debit",
        //           "title": "Grocery Shopping",
        //           "amount": 55.75,
        //           "updated": "2023-06-20"
        //         },
        //         {
        //           "id": 567,
        //           "type": "Credit",
        //           "title": "Salary Deposit",
        //           "amount": 2500,
        //           "updated": "2023-06-21"
        //         },
        //         {
        //           "id": 999,
        //           "type": "Debit",
        //           "title": "Restaurant Dinner",
        //           "amount": 75.5,
        //           "updated": "2023-06-22"
        //         },
        //         {
        //           "id": 789,
        //           "type": "Credit",
        //           "title": "Online Sales Revenue",
        //           "amount": 650.25,
        //           "updated": "2023-06-23"
        //         }
        //       ]

        // })
        this.fetchPickupDetails();
        this.fetchAgents();
    }

    public fetchPickupDetails() {
        this.setState({ showLoader: true });
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds,
        }
        axios.get(`pickupDetails/${this.state.pickup_id}`, { params: body }).then((response: any) => {
            if (response.data.success) {
                console.log("data", response.data.data);
                this.setState({ pickup_details: response.data.data, showLoader: false });
            } else {
                // console.log("err");
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchAgents() {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let agents: any = response.data.data;
                this.setState({ agentsLite: agents });
                console.log("agentsLite", this.state.agentsLite);
            });
        }
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);
        const maskedDetailValueSx = isUatEnvironment
            ? {
                filter: 'blur(4px)',
                opacity: 0.5,
                userSelect: 'none',
            }
            : undefined;
        const renderMaskedDetailValue = (value: React.ReactNode) => (
            <Box component="span" sx={maskedDetailValueSx}>
                {value}
            </Box>
        );

        const handleRouteMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };
        const closeRouteMoreOptions = () => {
            setTimeout(() => {
                this.setState({ anchorEl: null });
            }, 1);
        };

        const handleEditPickupDetails = ((data: any) => {
            closeRouteMoreOptions();
            this.setState({
                showEditPickupDetails: true,
                pickup_slot: this.state.pickup_details.slot_id,
                agent: this.state.pickup_details.agent_id,
                // location: this.state.pickup_details.location,
                status: this.state.pickup_details.pickup_status,
                payment: this.state.pickup_details.payment_status
            });
        })

        const handleEditCustomerDetails = ((data: any) => {
            closeRouteMoreOptions();
            this.setState({
                showEditCustomerDetails: true,
                name: this.state.pickup_details.cust_name,
                mobile: this.state.pickup_details.cust_phone,
                email: this.state.pickup_details.cust_email,
                house_number: this.state.pickup_details.cust_hno,
                street: this.state.pickup_details.cust_street,
                locality: this.state.pickup_details.cust_locality,
                state: this.state.pickup_details.cust_state,
                city: this.state.pickup_details.cust_city,
                pincode: this.state.pickup_details.cust_pincode,
                landmark: this.state.pickup_details.cust_landmark,
                attended_customer: this.state.pickup_details.cust_attended,
            })
        })

        const handleUpdatePickupDetails = (() => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": this.state.pickup_id,
                "slot_id": this.state.pickup_slot,
                // "agent_id": this.state.agent,
                "pickup_status": this.state.status,
                "payment_status": this.state.payment,
            }
            axios.post('editPickupDetails', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("response", response.data.data);
                    toast.success(t("Pickup Details Updated"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                    this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                } else {
                    this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleChangeAgent = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": this.state.pickup_id,
                "agent_id": this.state.agent,
            }
            axios.post('editPickupDetails', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("response", response.data.data);
                    toast.success(t("Pickup Agent Updated"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                    this.setState({ showChangeBatchAgent: false, agent: '', showLoader: false });
                } else {
                    this.setState({ showChangeBatchAgent: false, agent: '', showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showChangeBatchAgent: false, agent: '', showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        // const handleDeleteConfirmation = (row: any) => {
        //     this.setState({
        //       showDeleteItemConfirmation: true,
        //       itemToDelete: row
        //     });
        // }

        const handleUpdateCustomerDetails = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": this.state.pickup_id,
                "cust_name": this.state.name,
                "cust_phone": this.state.mobile,
                "cust_email": this.state.email,
                "cust_hno": this.state.house_number,
                "cust_street": this.state.street,
                "cust_locality": this.state.locality,
                "cust_city": this.state.city,
                "cust_state": this.state.state,
                "cust_pincode": this.state.pincode,
                "cust_landmark": this.state.landmark,
                "cust_attended": this.state.attended_customer,
            }
            axios.post('editPickupDetails', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("response", response.data.data);
                    toast.success(t("Pickup Details Updated"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                    this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                } else {
                    this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showEditCustomerDetails: false, showEditPickupDetails: false, pickup_slot: "", status: "", payment: "" });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleAddBag = () => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": this.state.pickup_id,
                "uid": this.state.bagUid,
                "weight": this.state.bagWeight,
                "forceSave": this.state.forceAddBag
            }
            axios.post('addPickupBag', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log(response.data.data);
                    // this.setState({ bagUid: '', bagWeight: '', showAddBag: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    
                    /**Script to remove the bag from inventory starts here*/
                    let body1 = { 'barcode': this.state.bagUid };
                    axios.post('removeBarcode', body1, { headers: { "Content-Type": "application/json" } }).then((response1: any) => {
                        if (response1.data.success) {
                            toast.success("Bag removed from inventory successfully", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        }else{
                            toast.error("Something went wrong while removing Bag from inventory!", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        }
                    }).catch((error) => {
                        toast.error(error.response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    });
                    /**Script to remove the bag from inventory ends here*/

                    this.setState({ bagUid: '', bagWeight: '', showAddBag: false });
                    this.fetchPickupDetails();
                } else {
                    // console.log("err");
                    this.setState({ bagUid: '', bagWeight: '', showAddBag: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ bagUid: '', bagWeight: '', showAddBag: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleEditBag = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "bag_type": this.state.bagDetails.bag_type,
                "created_at": this.state.bagDetails.created_at,
                "flag": this.state.bagDetails.flag,
                "flag_image": this.state.bagDetails.flag_image,
                "flag_images": null,
                "id": this.state.bagDetails.id,
                "pickup_bag_id": this.state.bagDetails.id,
                "pickup_id": this.state.bagDetails.pickup_id,
                "uid": this.state.bagDetails.uid,
                "updated_at": this.state.bagDetails.updated_at,
                "weight": this.state.bagDetails.weight,
            }
            // console.log("body",body);
            axios.post('editPickupBag', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showEditBag: false, showLoader: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                } else {
                    this.setState({ showEditBag: false, showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showEditBag: false, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleAddTransaction = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "amount": this.state.transactionAmount,
                "comments": this.state.transactionComment,
                "is_canceled": this.state.transactionIsCanceled,
                "is_completed": this.state.transactionIsCompleted,
                "pickup_id": this.state.pickup_id,
                "type": this.state.transactionType,
            }
            axios.post('addPickupTransaction', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("resp", response.data.data);
                    toast.success("Transaction Added Successfully", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                    this.fetchPickupDetails();
                } else {
                    this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleEditTransaction = (transaction: any) => {
            this.setState({
                transactionId: transaction.id,
                transactionType: transaction.type,
                transactionAmount: transaction.amount,
                transactionComment: transaction.comments,
                transactionIsCompleted: transaction.is_completed,
                transactionIsCanceled: transaction.is_cancelled
            });
        }

        const handleClearTransaction = () => {
            this.setState({
                transactionId: '',
                transactionType: '',
                transactionAmount: '',
                transactionComment: '',
                transactionIsCompleted: '',
                transactionIsCanceled: ''
            });
        }

        const handleUpdateTransaction = () => {
            this.setState({ showLoader: true });
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": this.state.pickup_id,
                "pickup_payment_id": this.state.transactionId,
                "type": this.state.transactionType,
                "amount": this.state.transactionAmount,
                "comments": this.state.transactionComment,
                "is_completed": this.state.transactionIsCompleted,
                "is_cancelled": this.state.transactionIsCanceled
            }
            axios.post('editPickupTransaction', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("resp", response.data.data);
                    toast.success("Transaction Updated Successfully", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                    this.fetchPickupDetails();
                } else {
                    this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddTransaction: false, showLoader: false }, () => handleClearTransaction());
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleDeleteTransaction = () => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "payment_id": this.state.transactionId
            }
            axios.post('removePickupTransaction', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    // console.log("resp", response.data.data);
                    toast.success("Transaction Deleted Successfully", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.setState({ showDeleteTransactionDialog: false, transactionId: '' });
                    this.fetchPickupDetails();
                } else {
                    this.setState({ showDeleteTransactionDialog: false, transactionId: '' });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showDeleteTransactionDialog: false, transactionId: '' });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleDeleteBag = (bagId: any) => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_bag_id": bagId,
            }
            axios.post('unlinkPickupBag', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                } else {
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const subTotal = () => {
            // this.state.pickup_details.items.forEa
            let sum = 0;
            this.state.pickup_details.items?.map((row: any) => {
                sum += row.qty * row.price;
            })
            return formatCurrency(sum.toFixed(2));
        }

        const handleDeletePickupItem = (row: any) => {
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "id": row.id,
                "item_id": row.item_id,
                "pickup_id": this.state.pickup_id,
                "qty": row.qty,
            }
            axios.post('deletePickupItem', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchPickupDetails();
                } else {
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
        const handleAddWeight = () => {
            const { pickup_id, newWeight } = this.state;
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "pickup_id": pickup_id,
                "qty": parseFloat(newWeight),
            }
            axios.post('addPickupItem', body, { headers: { "Content-Type": "application/json" } })
                .then((response: any) => {
                    if (response.data.success) {
                        toast.success(response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                        this.fetchPickupDetails();
                        this.setState({ addWeightChecked: false, newWeight: "" });
                    } else {
                        toast.error(response.data.msg, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                        let errors = response.data.errors;
                        for (var error in errors) {
                            toast.error(errors[error][0], {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored"
                            });
                        }
                    }
                }).catch((error) => {
                    toast.error(error.response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                });
        }
        const handlePriorityChange = (event: any) => {
            console.log(event.currentTarget.value);
        };

        const transaction_columns: any = [
            // {
            //     headerName: "Id",
            //     field: "id",
            //     width: 80
            // },
            {
                headerName: "Type",
                field: "type",
                width: 70,
            },
            {
                headerName: "Amount",
                field: "amount",
                width: 80,
            },
            {
                headerName: "Comments",
                field: 'comments',
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <Tooltip title={params.row.comments}>
                        <span className='tableCellTruncate'>{params.row.comments}</span>
                    </Tooltip>
                )
            },
            {
                headerName: "Status",
                field: "status",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <span>{(params.row.is_completed) ? 'Paid' : 'Due'} / {(params.row.is_cancelled) ? 'Cancelled' : 'Approved'}</span>
                )
            },
            {
                headerName: "Updated",
                field: "updated_at",
                width: 160
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        icon={<EditOutlined className='customIconButton' />}
                        label="Edit Transaction"
                        onClick={() => this.setState({ showAddTransaction: true }, () => handleEditTransaction(params.row))}
                    // showInMenu
                    />,
                    <GridActionsCellItem
                        icon={<DeleteOutlined color='error' />}
                        label="Delete Transaction"
                        onClick={() => this.setState({ showDeleteTransactionDialog: true, transactionId: params.row.id })}
                    // showInMenu
                    />
                ]
            }
        ];

        const comments_column: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: "Comment",
                field: "comment",
                width: 250
            },
            {
                headerName: "Status",
                field: "status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.status == 'complete') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.status == 'complete' ? "Complete" : "Pending"}</Typography>
                )
            },
            {
                headerName: "UserID",
                field: "user_id",
                width: 150,
            },
            {
                headerName: "Updated At",
                field: "created_at",
                width: 200,
            }

        ]

        const currentDate = new Date();
        const thirtyDaysBeforeDate = new Date(currentDate.setDate(currentDate.getDate() - 30));
        const disabled = (this.state.pickup_details.pickup_status == "complete" || new Date(this.state.pickup_details.pickup_date) < thirtyDaysBeforeDate) ? true : false;
        let deleteTooltip = "Delete Bag";
        if (disabled) {
            if(this.state.pickup_details.pickup_status == "complete") {
                deleteTooltip = "Bags cannot be deleted for completed pickups";
            } else {
                deleteTooltip = "Bags cannot be deleted for pickups older than 30 days";
            }
        }

        const bagsColumn: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: "UID",
                field: "uid",
                width: 110
            },
            {
                headerName: "Weight",
                field: "weight",
                width: 80
            },
            {
                headerName: "Added",
                field: "created_at",
                width: 160
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    /*<GridActionsCellItem
                        icon={<EditOutlined className='customIconButton' />}
                        label="Edit Bag"
                        onClick={() => this.setState({ bagDetails: params.row, showEditBag: true })}
                    // bagUid: params.row.uid, bagWeight: params.row.weight 
                    // showInMenu
                    />,*/
                    <GridActionsCellItem
                        icon={
                            <Tooltip title={deleteTooltip}>
                            <DeleteOutlined color={disabled ? 'disabled' : 'error'}  />
                            </Tooltip>
                        }
                        label="Delete Bag"
                        onClick={() => !disabled && this.setState({ showDeleteBagConfirmation: true, bagToDelete: params.row.id })}
                    // showInMenu
                    />
                ]
            }
        ]

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                // avatar={
                                //     <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/operations/batch-pickups'}><KeyboardArrowLeftRounded /></Button>
                                // }
                                avatar={
                                       <Button
                                           size="small"
                                           variant="outlined"
                                           className="customBackButton"
                                        onClick={() => {
                                          
                                               if (this.props.history.length > 1) {
                                                   this.props.history.goBack();
                                               } else {
                                                      this.props.history.push('/operations/batch-pickups');
                                                  
                                               }
                                           }}
                                       >
                                           <KeyboardArrowLeftRounded />
                                       </Button>
                                    }

                                
                                title="Pickup Details"
                                className="text-left"
                                action={
                                    <IconButton aria-label="route-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleRouteMoreOptions(e)}>
                                        <MoreHorizOutlined id="route-more-options-button" sx={{ outline: 'none !important' }} />
                                        <Menu
                                            id="route-more-options-menu"
                                            aria-labelledby="route-more-options-button"
                                            anchorEl={this.state.anchorEl}
                                            open={open}
                                            onClose={() => closeRouteMoreOptions()}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            <MenuItem className='customMenuItem' onClick={() => handleEditPickupDetails(this.state.pickup_details)}>{t("Edit Pickup Details")}</MenuItem>
                                            <MenuItem className='customMenuItem' onClick={() => handleEditCustomerDetails(this.state.customer_details)}>{t("Edit Customer Details")}</MenuItem>

                                            {/* <MenuItem className='customMenuItem' onClick={() => closeRouteMoreOptions()}>Delete Route</MenuItem> */}
                                        </Menu>
                                    </IconButton>
                                } />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails" sx={{ minHeight: '580px' }}>
                                            <CardHeader title="Pickup Details" />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Pickup ID:
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(
                                                            <>#{this.state.pickup_details.id}</>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        Pickup Type
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(
                                                            <>
                                                                {this.state.pickup_details.pickup_type}&nbsp;
                                                                ({this.state.pickup_details?.community?.name})
                                                            </>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Batch
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(
                                                            this.state.pickup_details.community_pickup_group_id + "(" + this.state.pickup_details.pickup_status + ")"
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Pickup Date
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.pickup_date)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Pickup Slot
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.pickup_slot)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Agent
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.agent_name)}
                                                        <IconButton color="primary" className='customIconButton' aria-label="Update Agent" component="span" onClick={() => this.setState({ showChangeBatchAgent: true, agent: this.state.pickup_details.agent_id })}>
                                                            <EditOutlined />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Zone
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.zone_id || 'Not Selected')}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Location
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(
                                                            <>
                                                                {this.state.pickup_details.cust_lat || '-'}, {this.state.pickup_details.cust_lng || '-'}
                                                            </>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Status
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {/* {this.state.pickup_details.pickup_status} */}
                                                        {renderMaskedDetailValue(
                                                            <Typography className={(this.state.pickup_details.pickup_status == 'complete' ? 'statusTextSuccess' : 'statusTextError')} sx={{ textTransform: 'capitalize' }}>{this.state.pickup_details.pickup_status}</Typography>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Payment
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {/* {this.state.pickup_details.payment_status} */}
                                                        {renderMaskedDetailValue(
                                                            <Typography className={(this.state.pickup_details.payment_status == 'complete' ? 'statusTextSuccess' : 'statusTextError')} sx={{ textTransform: 'capitalize' }}>{this.state.pickup_details.payment_status}</Typography>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Pickup Added
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.created_at)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        QR Code Scanned
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(this.state.pickup_details.qrcode_scanned_time || 'Not scanned yet')}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails" sx={{ minHeight: '580px' }}>
                                            <CardHeader title="Customer Details" />
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Name
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {renderMaskedDetailValue(
                                                            <Link to={`/neighbourhood/customers/${this.state.pickup_details.user_id}`} style={{ textDecoration: 'none', fontWeight: 700 }}>{this.state.pickup_details.cust_name}</Link>
                                                        )}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Mobile
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_phone)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Email
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_email)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        House No.
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_hno)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Street
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_street)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Locality
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_locality)}
                                                    </Grid><Grid item md={6} xs={6} className='detailsTitle'>
                                                        City
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_city)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        State
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_state)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Pincode
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_pincode)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Landmark
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_landmark)}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Attended Customer
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {renderMaskedDetailValue(this.state.pickup_details.cust_attended)}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                                <TableHead>
                                    <TableRow>
                                        {/*<TableCell sx={{ border: 1, borderColor: 'grey.300', fontWeight: 700 }} align="center">Action</TableCell>*/}
                                        <TableCell sx={{ border: 1, borderColor: 'grey.300', fontWeight: 700 }}>Unit</TableCell>
                                        <TableCell sx={{ border: 1, borderColor: 'grey.300', fontWeight: 700 }}>Description</TableCell>
                                        <TableCell sx={{ border: 1, borderColor: 'grey.300', fontWeight: 700 }} align="right">Price</TableCell>
                                        <TableCell sx={{ border: 1, borderColor: 'grey.300', fontWeight: 700 }} align="right">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.pickup_details.items?.map((row: any) => (
                                        <TableRow key={row.id}>
                                            {/*<TableCell sx={{ border: 1, borderColor: 'grey.300' }} align='center'>
                                                <IconButton size='small' color='error'>
                                                    <DeleteOutlineOutlinedIcon onClick={() => handleDeleteConfirmation(row)} />
                                                </IconButton>
                                            </TableCell>*/}
                                            <TableCell sx={{ border: 1, borderColor: 'grey.300' }}>{row.qty + " kg"}</TableCell>
                                            <TableCell sx={{ border: 1, borderColor: 'grey.300' }}>{row.item_name}</TableCell>
                                            <TableCell sx={{ border: 1, borderColor: 'grey.300' }} align="right">{formatCurrency(row.price)}</TableCell>
                                            <TableCell sx={{ border: 1, borderColor: 'grey.300' }} align="right">{formatCurrency((row.price * row.qty).toFixed(2))}</TableCell>
                                        </TableRow>
                                    ))}
                                    {/*<TableRow>
                                            <TableCell align="center">
                                            <Checkbox
                                                checked={this.state.addWeightChecked}
                                                onChange={(e:any) => this.setState({ addWeightChecked: e.target.checked })}
                                            />
                                            </TableCell>
                                            <TableCell>
                                            <TextField
                                                type="number"
                                                placeholder="Enter weight"
                                                value={this.state.newWeight || ""}
                                                onChange={(e) => this.setState({ newWeight: e.target.value })}
                                                disabled={!this.state.addWeightChecked}
                                                fullWidth
                                            />
                                            </TableCell>
                                            <TableCell colSpan={3} align="right">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleAddWeight()}
                                                disabled={!this.state.addWeightChecked || !this.state.newWeight}
                                            >
                                                Add Weight
                                            </Button>
                                            </TableCell>
                                    </TableRow>*/}
                                    <TableRow>
                                        {/* <TableCell rowSpan={3} /> */}
                                        <TableCell rowSpan={3} />
                                        <TableCell rowSpan={3} />
                                        <TableCell colSpan={1}>Subtotal</TableCell>
                                        <TableCell align="right">{subTotal()}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {/* <TableCell rowSpan={2}/> */}
                                        <TableCell colSpan={1}>Shipping</TableCell>
                                        <TableCell align="right">{0}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {/* <TableCell rowSpan={2}/> */}
                                        <TableCell className='font-weight-bold' colSpan={1}>Total</TableCell>
                                        <TableCell className='font-weight-bold' align="right">{"Rs. " + subTotal()}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={5} align="right">*Exclusive of all taxes</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="stretch">
                    {/* <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Transactions"
                                className="text-left"
                                action={
                                    <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddTransaction: true }, () => handleClearTransaction())}>{t("Add Transaction")}</Button>
                                }
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="Payments"
                                    columns={transaction_columns}
                                    rows={this.state.pickup_details?.payments}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid> */}
                    <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Bags"
                                className="text-left"
                                action={
                                    <Button size='small' variant='contained' onClick={() => this.setState({ showAddBag: true })}>{t("Add Bag")}</Button>
                                }
                            />
                            <CardContent>
                            <div style={{ height: "632px", width: "100%" }}>
                                <DataGrid
                                    aria-label="Bags"
                                    columns={bagsColumn}
                                    rows={this.state.pickup_details.bags}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    disableVirtualization    
                                />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    {/* <Grid item md={6} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Attachments"
                                className="text-left"
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="Payments"
                                    columns={transaction_columns}
                                    rows={this.state.transaction_data}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid> */}
                    <Grid item md={6} xs={12} className="mt-3">
                    <Grid container direction="column" spacing={2}>
                    <Grid item md={6} xs={12}>
                        <Card>
                            <CardHeader
                                title="Comments"
                                className="text-left"
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label="Comments"
                                    columns={comments_column}
                                    rows={this.state.pickup_details.comments}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item md={6} xs={12} >

                        <Card sx={{ height: '100%' }}>
                            <CardHeader
                                title="Unsynced Bags"
                                className="text-left"
                            />
                            <CardContent>
                            <div style={{ height: "260.9px", width: "100%" }}>
                                <DataGrid
                                    aria-label="Bags"
                                    columns={transaction_columns}
                                    rows={this.state.transaction_data}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                />
                                </div>
                            </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Modal
                    open={this.state.showEditPickupDetails}
                    onClose={() => this.setState({ showEditPickupDetails: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Edit Pickup Details")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showEditPickupDetails: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Pickup Slot")}</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.pickup_slot}
                                                onChange={(e) => this.setState({ pickup_slot: e.target.value })}
                                                displayEmpty
                                                label={t("Pickup Slot")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"Morning"} value={20}>{"Morning"}</MenuItem>
                                                <MenuItem key={"Afternoon"} value={21}>{"Afternoon"}</MenuItem>
                                                <MenuItem key={"Evening"} value={22}>{"Evening"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Agent")} *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.agent}
                                                onChange={(e) => this.setState({ agent: e.target.value })}
                                                displayEmpty
                                                label={t("Agent")}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.agentsLite?.map((el: any) => {
                                                        return(
                                                            <MenuItem key={el.name} value={el.id}>{el.name}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                                    {/* <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Location") + " *"}
                                            value={this.state.location}
                                            onChange={(e: any) => this.setState({ location: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid> */}
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Status")}</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.status}
                                                onChange={(e) => this.setState({ status: e.target.value })}
                                                displayEmpty
                                                label={t("Status")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"Pending"} value={"pending"}>{"Pending"}</MenuItem>
                                                <MenuItem key={"Cancelled"} value={"cancelled"}>{"Cancelled"}</MenuItem>
                                                <MenuItem key={"Complete"} value={"complete"}>{"Complete"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Payment")} *</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.payment}
                                                onChange={(e) => this.setState({ payment: e.target.value })}
                                                displayEmpty
                                                label={t("Payment") + " *"}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"Pending"} value={"pending"}>{"Pending"}</MenuItem>
                                                <MenuItem key={"Cancelled"} value={"cancelled"}>{"Cancelled"}</MenuItem>
                                                <MenuItem key={"Complete"} value={"complete"}>{"Complete"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showEditPickupDetails: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleUpdatePickupDetails()}>{t("Update")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showEditCustomerDetails}
                    onClose={() => this.setState({ showEditCustomerDetails: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Edit Customer Details")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showEditCustomerDetails: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Name")}
                                            value={this.state.name}
                                            onChange={(e: any) => this.setState({ name: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Mobile")}
                                            value={this.state.mobile}
                                            onChange={(e: any) => this.setState({ mobile: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Email")}
                                            value={this.state.email}
                                            onChange={(e: any) => this.setState({ email: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("H.No.")}
                                            value={this.state.house_number}
                                            onChange={(e: any) => this.setState({ house_number: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Street")}
                                            value={this.state.street}
                                            onChange={(e: any) => this.setState({ street: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Locality")}
                                            value={this.state.locality}
                                            onChange={(e: any) => this.setState({ locality: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("City")}
                                            value={this.state.city}
                                            onChange={(e: any) => this.setState({ city: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Pincode")}
                                            value={this.state.pincode}
                                            onChange={(e: any) => this.setState({ pincode: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("State")}
                                            value={this.state.state}
                                            onChange={(e: any) => this.setState({ state: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Landmark")}
                                            value={this.state.landmark}
                                            onChange={(e: any) => this.setState({ landmark: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Attended Customer")}
                                            value={this.state.attended_customer}
                                            onChange={(e: any) => this.setState({ attended_customer: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showEditCustomerDetails: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleUpdateCustomerDetails()}>{t("Update")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showAddBag}
                    onClose={() => this.setState({ showAddBag: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Add Bag")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddBag: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className='mb-3' />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("UID")}
                                            value={this.state.bagUid}
                                            onChange={(e: any) => this.setState({ bagUid: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Weight")}
                                            value={this.state.bagWeight}
                                            onChange={(e: any) => this.setState({ bagWeight: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions className='float-left'>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ forceAddBag: true }, () => handleAddBag())}><WarningAmberOutlinedIcon />{t("Force Add")}</Button>
                            </CardActions>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddBag: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddBag()}>{t("Add")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showEditBag}
                    onClose={() => this.setState({ showEditBag: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Update Bag")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showEditBag: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className='mb-3' />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("UID")}
                                            value={this.state.bagDetails.uid}
                                            onChange={(e: any) => this.setState({ bagDetails: { ...this.state.bagDetails, uid: e.target.value } })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Weight")}
                                            value={this.state.bagDetails.weight}
                                            onChange={(e: any) => this.setState({ bagDetails: { ...this.state.bagDetails, weight: e.target.value } })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showEditBag: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleEditBag()}>{t("Update")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showAddTransaction}
                    onClose={() => this.setState({ showAddTransaction: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={((this.state.transactionId) ? t("Edit") : t("Add")) + " " + t("Trasaction")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddTransaction: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className='mb-3' />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Type")}</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.transactionType}
                                                onChange={(e) => this.setState({ transactionType: e.target.value })}
                                                displayEmpty
                                                label={t("Type")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"cash"} value={"cash"}>{"Cash"}</MenuItem>
                                                <MenuItem key={"paytm"} value={"paytm"}>{"payTM"}</MenuItem>
                                                <MenuItem key={"wvi_hq"} value={"wvi_hq"}>{"Head Quarter"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Amount")}
                                            value={this.state.transactionAmount}
                                            onChange={(e: any) => this.setState({ transactionAmount: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="route-address-input"
                                            label={t("Comment")}
                                            value={this.state.transactionComment}
                                            onChange={(e: any) => this.setState({ transactionComment: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Is Completed?")}</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.transactionIsCompleted}
                                                onChange={(e) => this.setState({ transactionIsCompleted: e.target.value })}
                                                displayEmpty
                                                label={t("Is Completed?")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"yes"} value={"1"}>{"Yes"}</MenuItem>
                                                <MenuItem key={"no"} value={"0"}>{"No"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="city-label">{t("Is Canceled?")}</InputLabel>
                                            <Select
                                                labelId="city-label"
                                                value={this.state.transactionIsCanceled}
                                                onChange={(e) => this.setState({ transactionIsCanceled: e.target.value })}
                                                displayEmpty
                                                label={t("Is Canceled?")}
                                                fullWidth={true}
                                            >
                                                <MenuItem key={"yes"} value={"1"}>{"Yes"}</MenuItem>
                                                <MenuItem key={"no"} value={"0"}>{"No"}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddTransaction: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.state.transactionId ? handleUpdateTransaction() : handleAddTransaction()}>{(this.state.transactionId ? "Edit" : "Add") + " Transaction"}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showChangeBatchAgent}
                    onClose={() => this.setState({ showChangeBatchAgent: false })}
                    fullWidth={true}
                // PaperProps={{
                //     component: 'form',
                //     onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                //         event.preventDefault();
                //         const formData = new FormData(event.currentTarget);
                //         const formJson = Object.fromEntries((formData as any).entries());
                //         const email = formJson.email;
                //         console.log(email);
                //         handleClose();
                //     },
                // }}
                >
                    <DialogTitle>Change Agent</DialogTitle>
                    <DialogContent>
                        <Divider className="mb-3" />
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item md={6} xs={12}>
                                <FormControl fullWidth={true}>
                                    <InputLabel id="city-label">{t("Agent")} *</InputLabel>
                                    <Select
                                        labelId="city-label"
                                        value={this.state.agent}
                                        onChange={(e) => this.setState({ agent: e.target.value })}
                                        displayEmpty
                                        label={t("Agent")}
                                        fullWidth={true}
                                    >
                                        {
                                            this.state.agentsLite?.map((el: any) => {
                                                return (
                                                    <MenuItem key={el.name} value={el.id}>{el.name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size='small' className='customCloseButton' onClick={() => this.setState({ showChangeBatchAgent: false })}>{t("Close")}</Button>
                        <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleChangeAgent()}>{t("Update Agent")}</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                open={this.state.showDeleteItemConfirmation}
                onClose={() => this.setState({ showDeleteItemConfirmation: false, itemToDelete: null })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">
                    {t("Are you sure you want to delete this item?")}
                </DialogTitle>
                <DialogActions>
                    <Button className='customCloseButton'  onClick={() => this.setState({ showDeleteItemConfirmation: false, itemToDelete: null })}>{t("Cancel")}</Button>
                    <Button variant="contained" onClick={() => {
                    if (this.state.itemToDelete) {
                        handleDeletePickupItem(this.state.itemToDelete);
                    }
                    this.setState({ showDeleteItemConfirmation: false, itemToDelete: null });
                    }} color="error" autoFocus>{t("Delete")}</Button>
                </DialogActions>
                </Dialog>
                <Dialog
                open={this.state.showDeleteBagConfirmation}
                onClose={() => this.setState({ showDeleteBagConfirmation: false, bagToDelete: null })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">
                    {t("Are you sure you want to delete this bag?")}
                </DialogTitle>
                <DialogActions>
                    <Button className='customCloseButton' onClick={() => this.setState({ showDeleteBagConfirmation: false, bagToDelete: null })}>{t("Cancel")}</Button>
                    <Button onClick={() => {
                    if (this.state.bagToDelete) {
                        handleDeleteBag(this.state.bagToDelete);
                    }
                    this.setState({ showDeleteBagConfirmation: false, bagToDelete: null });
                    }} color="error" variant="contained" autoFocus>{t("Delete")}</Button>
                </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.showDeleteTransactionDialog}
                    onClose={() => this.setState({ showDeleteTransactionDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this transaction ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button variant='contained' onClick={() => this.setState({ showDeleteTransactionDialog: false })}>{t("Cancel")}</Button>
                        <Button variant='contained' color='error' onClick={() => handleDeleteTransaction()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(PickupDetails))
